<script>
    import Scene from "./Scene.svelte";
    import NineLeaders from "../pre-comps/Elements/NineLeaders.svelte";
    import CountUpToNine from "../pre-comps/Elements/CountUpToNine.svelte";

    const layers = [
        CountUpToNine,
        NineLeaders,
    ];
</script>

<Scene layers={layers}></Scene>